import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-palumbo-black text-palumbo-copper font-display uppercase tracking-widest">
        Caricamento...
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
